import React, { useRef, useState } from 'react';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
import i18n from 'i18next';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';

import { Confirmation } from '../../notification/';
import { RoundedPaletteColors } from '../../../../constants';
import EditIcon from '../../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../../assets/icons/delete.svg?react';
import './calendarmenu.scss';

export const CalendarMenu = (props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuPlacement, setMenuPlacement] = useState('bottom-end');

  const buttonRef = useRef(null);

  const {
    id,
    onCalendarColorModify,
    onCalendarDelete,
    onCalendarOpenCalnendarView,
    accessRole,
    isPrimary,
    color,
    isIframeContainer
  } = props;

  const beforeRoundedTileRender = (args) => {
    args.element.classList.add('e-rounded-palette');
  };

  const roundedPaletteChange = (args) => {
    onCalendarColorModify(id, args.currentValue.hex);
  };

  const handleConfirm = () => {
    setShowConfirmation(true);
  };

  const acceptConfirmation = () => {
    onCalendarDelete(id, props);
    setShowConfirmation(false);
  };

  const cancelConfirmation = () => {
    setShowConfirmation(false);
  };

  const MENU_MIN_HEIGHT = 360;

  const toggleMenu = () => {
    if (!isMenuOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setMenuPlacement(spaceBelow < MENU_MIN_HEIGHT ? 'top-end' : 'bottom-end');
    }
    setIsMenuOpen((prevIsOpen) => !prevIsOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  if (isIframeContainer) {
    return null;
  }

  return (
    <div className="menu-config-calendar-container">
      <button
        type="button"
        className="menubutton"
        aria-haspopup="menu"
        aria-expanded={isMenuOpen}
        onClick={toggleMenu}
        ref={buttonRef}
      >
        <span className={`lf-icon-kebab-menu calendar-menu-icon`}></span>
      </button>

      <Overlay
        target={buttonRef.current}
        show={isMenuOpen}
        placement={menuPlacement}
        rootClose
        onHide={closeMenu}
        containerPadding={8}
      >
        <Popover 
          id={`calendar-menu-${id}`}
          className="menupanel"
          role="menu"
          placement="right"
        >
          <Popover.Body>
            <div className="calendar-menu-actions-container">
              <div
                id={id}
                className={`mb-2 menuitem e-controle-CalendarId e-field e-control e-dropdownlist ${
                  accessRole !== 'owner' ? 'hidden' : ''
                }`}
                onClick={(e) => {
                  onCalendarOpenCalnendarView(e);
                  closeMenu();
                }}
                role="button"
                tabIndex={0}
              >
                <EditIcon className="calendar-menu-action-icon"/>
                <span className="text-color-grey-800 inter-regular-14 ml-3">
                  {i18n.t("calendar-sidebar.edit")}
                </span>
              </div>
              <div
                id={`${id}_remove`}
                className={`mb-2 menuitem e-controle-CalendarId e-field e-control e-dropdownlist ${
                  isPrimary || accessRole !== 'owner'
                    ? 'hidden'
                    : ''
                }`}
                onClick={() => {
                  handleConfirm();
                  closeMenu();
                }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleConfirm();
                    closeMenu();
                  }
                }}
              >
                <DeleteIcon className="calendar-menu-action-icon" />
                <span className="text-color-grey-800 inter-regular-14 ml-3">
                  {i18n.t("calendar-sidebar.remove")}
                </span>
              </div>
            </div>
            <div className={`e-rounded-wrap`}>
              <ColorPickerComponent
                value={color}
                id="rounded-palette"
                mode="Palette"
                modeSwitcher={false}
                inline={true}
                showButtons={false}
                columns={4}
                presetColors={RoundedPaletteColors}
                beforeTileRender={beforeRoundedTileRender}
                change={roundedPaletteChange}
              ></ColorPickerComponent>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
      <Confirmation
        initialModalState={showConfirmation}
        onAccept={() => {
          acceptConfirmation();
        }}
        onCancel={() => {
          cancelConfirmation();
        }}
        titleAccept="Aceptar"
        titleCancel="Cancelar"
        message={i18n.t('calendar-sidebar.confirm_calendar')}
        confirmType="confirm-info"
        iconType="lf-icon lf-icon-information"
      />
    </div>
  );
};

export default CalendarMenu;
